import React, { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
const DeallocateModal = props => {
    const { t } = useTranslation();
    const base_url_assets = process.env.REACT_APP_BASE_ASSETS_URL;
    const { deallcocation_order_close, deallcocation_deallocate } = props;
    const [comment, setComment] = useState('');
    const [commentError, setCommentError] = useState(false);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const commentSuggestions = [
        'Customer cancelled',
        'Reserve expired',
        'Released to stock',
        'Order cancelled',
    ];

    useEffect(() => {
        const modal = document.getElementById('deallcocat-modal');
        if (!modal) return undefined;
        const reset = () => {
            setComment('');
            setCommentError(false);
            setShowSuggestions(false);
        };
        modal.addEventListener('hidden.bs.modal', reset);
        return () => modal.removeEventListener('hidden.bs.modal', reset);
    }, []);

    const closeModal = () => {
        const modal = document.getElementById('deallcocat-modal');
        window.bootstrap?.Modal.getOrCreateInstance(modal)?.hide();
    };

    const confirmFree = () => {
        if (!comment.trim()) {
            setCommentError(true);
            return;
        }
        deallcocation_deallocate('YES', comment.trim());
        closeModal();
    };

    return (
        <>
            <div className="modal fade common-modal common-modal-danger" id="deallcocat-modal" tabIndex={-1} aria-labelledby="allocation-listedModalLabel" aria-hidden="true">

                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-body">
                            <img className="common-modal-exclamation-img" src={base_url_assets + "images/icons/exclamation-mark-red.png"} alt="" />
                            <p className="modal-content-text">{t("Are you sure you want to Free this item ?")}</p>
                            {/* <label className="w-100 text-start mt-3">
                                <span className="d-block mb-1">{t("Comment")}<span className="text-danger"> *</span></span>
                                <input type="text" className="form-control" />
                            </label> */}
                            {/* <div className="ds-dealloc-remark">
                                <span>{t("Remark")} :</span>
                                <input type="text" value={comment} />
                            </div> */}
                            <div className="ds-dealloc-remark">
                                <label className={`dc-field ${comment ? 'has-value' : ''} ${commentError ? 'has-error' : ''}`}>
                                    <input
                                        type="text"
                                        value={comment}
                                        placeholder=" "
                                        onChange={(e) => {
                                            setComment(e.target.value);
                                            if (e.target.value.trim()) setCommentError(false);
                                        }}
                                        onFocus={() => setShowSuggestions(true)}
                                        onBlur={() => setShowSuggestions(false)}
                                    />
                                    <span className="dc-field-label">
                                        {t("Comment")}
                                        <span className="dc-required">*</span>
                                    </span>
                                </label>
                                {showSuggestions && (
                                    <div className="ds-dealloc-remark-list">
                                        <span className="ds-dealloc-remark-title">{t("Suggestion")}</span>
                                        {commentSuggestions.map((suggestion) => (
                                            <span
                                                key={suggestion}
                                                className="ds-dealloc-remark-item"
                                                onMouseDown={(e) => e.preventDefault()}
                                                onClick={() => {
                                                    setComment(suggestion);
                                                    setCommentError(false);
                                                    setShowSuggestions(false);
                                                }}
                                            >
                                                {t(suggestion)}
                                            </span>
                                        ))}
                                    </div>
                                )}
                            </div>
                            {commentError && (
                                <span className="text-danger d-block mt-1">{t("Comment is required")}</span>
                            )}
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn modal-content-no" data-bs-dismiss="modal" onClick={() => deallcocation_order_close('NO', comment.trim())}>{t("No")}</button>
                            {/* <button type="button" className="btn modal-content-yes" data-bs-dismiss="modal" onClick={(e) => deallcocation_deallocate('YES')}>{t("Yes")}</button> */}
                            <button type="button" className="btn modal-content-yes" onClick={confirmFree}>{t("Yes")}</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default DeallocateModal;
